import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { eventSessionInvitationRepository } from "@/service/repository/eventSessionInvitationRepository";

export const useUserEventRegistrationsStore = defineStore('userEventRegistrations', () => {
	// State
	const registrations = ref([]);
	const isLoading = ref(false);
	const error = ref(null);

	// Getters
	const hasRegistrations = computed(() => registrations.value.length > 0);

	const upcomingRegistrations = computed(() => {
		const now = new Date();
		return registrations.value.filter(reg => {
			if (reg.status === 'cancelled') return false;
			const eventDate = new Date(reg.session.businessDate);
			return eventDate >= now;
		}).sort((a, b) => {
			const dateA = new Date(a.session.businessDate);
			const dateB = new Date(b.session.businessDate);
			return dateA - dateB;
		});
	});

	const cancelledRegistrations = computed(() => {
		return registrations.value
			.filter(reg => reg.status === 'cancelled')
			.sort((a, b) => {
				const dateA = new Date(a.session?.businessDate || 0);
				const dateB = new Date(b.session?.businessDate || 0);
				return dateB - dateA; // most recent first
			});
	});

	const pastRegistrations = computed(() => {
		const now = new Date();
		return registrations.value.filter(reg => {
			const eventDate = new Date(reg.session.businessDate);
			return eventDate < now;
		}).sort((a, b) => {
			const dateA = new Date(a.session.businessDate);
			const dateB = new Date(b.session.businessDate);
			return dateB - dateA; // Most recent past first
		});
	});

	// Actions
	function clearRegistrations() {
		registrations.value = [];
		error.value = null;
	}

	async function loadRegistrations(hostCode) {
		if (!hostCode) {
			error.value = 'No se proporcionó código de usuario.';
			return false;
		}

		isLoading.value = true;
		error.value = null;

		try {
			const response = await eventSessionInvitationRepository.getUserEventRegistrations(hostCode);

			if (response.result === 0) {
				registrations.value = response.registrations || [];
				return true;
			} else {
				error.value = 'Error al cargar los registros de eventos.';
				return false;
			}
		} catch (err) {
			console.error('Error loading event registrations:', err);
			error.value = 'Error de conexión.';
			return false;
		} finally {
			isLoading.value = false;
		}
	}

	return {
		// State
		registrations,
		isLoading,
		error,
		// Getters
		hasRegistrations,
		upcomingRegistrations,
		cancelledRegistrations,
		pastRegistrations,
		// Actions
		clearRegistrations,
		loadRegistrations,
	};
});

